export default class Field {
    fieldID: string;
    label: string;
    dataType: string;
    fieldType: string;
    options: any[];
    s3_subfolder: string;
    defaultValue: any;
    description: string;
    optional: boolean;

    constructor(fieldID: string, label: string, dataType: string, fieldType: string, options: any[], s3_subfolder: string, defaultValue: any, description: string = "", optional: boolean = false) {
        this.fieldID = fieldID;
        this.label = label;
        this.dataType = dataType;
        this.fieldType = fieldType;
        this.options = options;
        this.s3_subfolder = s3_subfolder;
        this.defaultValue = defaultValue;
        this.description = description;
        this.optional = optional;
    }
}
